import { memo } from "react";
import SoftBox from "components/SoftBox";
import { Typography } from "@mui/material";

const NodeLabel = ({ label, lblClass }) => {
  return (
    <SoftBox className={`custom-node-text ${lblClass}`}>
      <SoftBox>
        <Typography variant="caption" sx={{ fontSize: "14px", textAlign: "center" }}>
          {label}
        </Typography>
      </SoftBox>
    </SoftBox>
  );
};

export default memo(NodeLabel);
